export const KEEP_IMAGE_PROPORTIONS = true
